var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1097 9.23638C11.1321 11.6386 13.2171 12.438 13.2402 12.4482C13.2226 12.5046 12.9071 13.5874 12.1417 14.7059C11.4801 15.6729 10.7934 16.6364 9.71171 16.6563C8.64882 16.6759 8.30705 16.026 7.09187 16.026C5.87705 16.026 5.49732 16.6364 4.49118 16.6759C3.44705 16.7154 2.65196 15.6302 1.98485 14.6668C0.621679 12.696 -0.420064 9.0978 0.978734 6.66897C1.67363 5.4628 2.91545 4.699 4.26334 4.67941C5.28865 4.65986 6.25641 5.3692 6.88319 5.3692C7.50958 5.3692 8.68562 4.51615 9.92194 4.64143C10.4395 4.66298 11.8923 4.8505 12.8252 6.21602C12.7501 6.26262 11.0917 7.22803 11.1097 9.23638M9.11217 3.33759C9.6665 2.66659 10.0396 1.7325 9.93782 0.803085C9.13879 0.835199 8.17258 1.33554 7.59946 2.00616C7.08583 2.60004 6.636 3.55057 6.75737 4.46159C7.64798 4.53049 8.55781 4.00901 9.11217 3.33759",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.7d8b3203dc2807cd248f1eb6272ffe19.svg";
export { ForwardRef as ReactComponent };